import React, { useRef, useState, useEffect } from 'react';
import { QuoteIcon, StarIcon, MapPinIcon, ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
import { SectionHeading } from './ui/SectionHeading';
import { testimonials } from '../data/testimonials';
const CAROUSEL_IMAGES = ['https://cdn.magicpatterns.com/uploads/twDkv3KLYi1xBPVku13hUt/image.png', 'https://cdn.magicpatterns.com/uploads/p8htYw7SbDhxH9LihXw5a6/image.png', 'https://cdn.magicpatterns.com/uploads/efyQQMP6VqqALMfJ1oHxd6/image.png', 'https://cdn.magicpatterns.com/uploads/1jJdiGSu2UrLaVTLzntEpZ/image.png', 'https://cdn.magicpatterns.com/uploads/gEsSrk7daJ4nKbRHfQCer7/image.png', 'https://cdn.magicpatterns.com/uploads/22imC5sXcgKAcDy2uu4ZK6/image.png', 'https://cdn.magicpatterns.com/uploads/pxk71ycXdaBRjcaUH1yb4K/image.png', 'https://cdn.magicpatterns.com/uploads/dd6KSU1LNoVb6mQzrCHxnW/image.png', 'https://cdn.magicpatterns.com/uploads/xqRpvLBWeJPAAVxcvnYucs/image.png'];
export function Testimonials() {
  const scrollRef = useRef<HTMLUListElement>(null);
  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(true);
  const checkScroll = () => {
    if (scrollRef.current) {
      const {
        scrollLeft,
        scrollWidth,
        clientWidth
      } = scrollRef.current;
      setCanScrollLeft(scrollLeft > 0);
      setCanScrollRight(Math.ceil(scrollLeft + clientWidth) < scrollWidth);
    }
  };
  useEffect(() => {
    checkScroll();
    window.addEventListener('resize', checkScroll);
    return () => window.removeEventListener('resize', checkScroll);
  }, []);
  const scroll = (direction: 'left' | 'right') => {
    if (scrollRef.current) {
      const amount = scrollRef.current.clientWidth * 0.8;
      scrollRef.current.scrollBy({
        left: direction === 'left' ? -amount : amount,
        behavior: 'smooth'
      });
    }
  };
  return <section className="w-full overflow-hidden bg-cream py-16 lg:py-24" data-id="element-187" data-mp="1nlqq32dm2cmr">
      <div className="mx-auto max-w-6xl px-5 sm:px-8" data-id="element-188" data-mp="1no3i68d323dj">
        <div className="flex items-end justify-between gap-4" data-id="element-189" data-mp="1xgxx74jwnxjs">
          <SectionHeading overline="Comunidad" size="lg" align="left" title={<>
                Lo probaron.{' '}
                <span className="italic text-terracotta-500" data-id="element-191" data-mp="1ogszjm4ikdit">Les encantó.</span>
              </>} data-id="element-190" data-mp="1siwcygaqts6q" />
          <div className="hidden gap-2 sm:flex" data-id="element-192" data-mp="1jir9uicl1fyd">
            <button onClick={() => scroll('left')} disabled={!canScrollLeft} className="flex h-10 w-10 items-center justify-center rounded-full border border-gold-200/70 bg-bone text-sage-800 transition-colors disabled:opacity-50 hover:bg-gold-100" data-id="element-193" data-mp="1jhyc26vlq0sd">
              <ChevronLeftIcon className="h-5 w-5" data-id="element-194" data-mp="14stnm7y7r0bt" />
            </button>
            <button onClick={() => scroll('right')} disabled={!canScrollRight} className="flex h-10 w-10 items-center justify-center rounded-full border border-gold-200/70 bg-bone text-sage-800 transition-colors disabled:opacity-50 hover:bg-gold-100" data-id="element-195" data-mp="10rqc1xn77qge">
              <ChevronRightIcon className="h-5 w-5" data-id="element-196" data-mp="quvd5dn0jo1l" />
            </button>
          </div>
        </div>
      </div>

      <ul ref={scrollRef} onScroll={checkScroll} className="no-scrollbar mt-12 flex snap-x snap-mandatory gap-4 overflow-x-auto px-5 pb-8 sm:px-8" data-id="element-197" data-mp="32gnssrtutf3c">
        {testimonials.map(item => <li key={item.name} className="w-[85vw] flex-none snap-center sm:w-[400px]" data-id="element-198" data-mp="3cg4yh993vszb">
            <figure className="flex h-full flex-col justify-between rounded-3xl border border-gold-200/60 bg-bone p-7 transition-[transform,box-shadow] duration-200 ease-soft hover:-translate-y-1 hover:shadow-[0_22px_44px_-30px_rgba(56,52,44,0.6)]" data-id="element-199" data-mp="3ggym01imz5ro">
              <div data-id="element-200" data-mp="2onek6tdqcxlv">
                <div className="flex items-center justify-between" data-id="element-201" data-mp="2srcn7f66esk7">
                  <div className="flex gap-0.5" aria-hidden="true" data-id="element-202" data-mp="2sozviaam93ty">
                    {Array.from({
                  length: 5
                }).map((_, i) => <StarIcon key={i} className="h-3.5 w-3.5 fill-gold-400 text-gold-400" data-id="element-203" data-mp="210gbwizrkvz1" data-mpi={i} />)}
                  </div>
                  <QuoteIcon className="h-5 w-5 text-gold-200" aria-hidden="true" data-id="element-204" data-mp="250gnlvvhat2e" />
                </div>
                <blockquote className="mt-5 text-[15px] leading-relaxed text-sage-800" data-id="element-205" data-mp="1lxy9gupngxf0">
                  “{item.quote}”
                </blockquote>
              </div>
              <figcaption className="mt-8 flex items-center gap-3.5 border-t border-gold-200/60 pt-5" data-id="element-206" data-mp="1vmgbtgdkvckr">
                <img src={item.avatar} alt="" className="h-11 w-11 rounded-full object-cover ring-2 ring-gold-200" data-id="element-207" data-mp="1qvgalyxfe8cg" />
                <div data-id="element-208" data-mp="24md3lqv9krk1">
                  <p className="text-[14px] font-semibold text-sage-800" data-id="element-209" data-mp="24ltki6tvnx4f">
                    {item.name}
                  </p>
                  <p className="mt-0.5 flex items-center gap-1 text-[12px] text-terracotta-500" data-id="element-210" data-mp="1zqnxt5sniefa">
                    <MapPinIcon className="h-3 w-3" aria-hidden="true" data-id="element-211" data-mp="2ej7ylzsbw9tk" />
                    {item.location}
                  </p>
                </div>
              </figcaption>
            </figure>
          </li>)}
      </ul>

      {/* Auto-scrolling Image Carousel */}
      <div className="relative mt-10 w-full overflow-hidden" data-id="element-212" data-mp="fa16fv11r5vd">
        <div className="pointer-events-none absolute inset-y-0 left-0 z-10 w-16 bg-gradient-to-r from-cream to-transparent sm:w-32" data-id="element-213" data-mp="2qva45si8m8j3" />
        <div className="pointer-events-none absolute inset-y-0 right-0 z-10 w-16 bg-gradient-to-l from-cream to-transparent sm:w-32" data-id="element-214" data-mp="2vud8tbub2cqj" />
        
        <div className="flex w-max animate-[marquee_40s_linear_infinite] gap-3 sm:gap-4" data-id="element-215" data-mp="2m53erqfwijzs">
          {/* Double the images for seamless looping */}
          {[...CAROUSEL_IMAGES, ...CAROUSEL_IMAGES].map((src, idx) => <img key={idx} src={src} alt="" className="h-32 w-24 rounded-2xl object-cover sm:h-48 sm:w-36" data-id="element-216" data-mp="2c6npzu4cjmtg" data-mpi={idx} />)}
        </div>
      </div>
    </section>;
}